import { Component, OnDestroy } from '@angular/core';
import { DialogsService } from '../../services/dialogs.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { AuthorizationWraperService } from '../../services/authorization-wraper/authorization.wraper.service';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersAction } from '../../state-management/users/users.actions';
import { UsersEffects } from '../../state-management/users/users.effects';
import { Subscription } from 'rxjs';
import { LoginWraperService } from '../../services/login.wraper.service';
import { AuthorizationResultPayload } from '../../models/authorization/authorization-result-payload.model';
import { AuthorizationScenario } from '../../enum/authorization-scenario.enum';
import { ApplicationMessagesAction } from '../../state-management/application-messages/application-message.action';
import { HubAuthorizationComponent } from '../../components/hub-authorization/hub-authorization.component';

@Component({
    selector: 'unlocking-account',
    styleUrls: ['./unlocking-account.component.scss'],
    templateUrl: './unlocking-account.component.html',
})
export class UnlockingAccountComponent implements OnDestroy {

    public pending: boolean;
    private urlToken: string;
    private secondFactorRequired: boolean;
    private authorizationPanel: MatDialogRef<HubAuthorizationComponent>;
    private result: Subscription;
    private authenticationSubscription: Subscription;

    constructor(
        private dialogsService: DialogsService,
        private activatedRoute: ActivatedRoute,
        private store: Store<AppState>,
        private authorizationWraper: AuthorizationWraperService,
        private usersEffects: UsersEffects,
        private loginWraper: LoginWraperService,
    ) {
        // Token de desbloqueio
        this.urlToken = this.activatedRoute.snapshot.params.token;
        this.authenticationSubscription = this.store.select((s) => s.authentication)
            .subscribe((state) => {
                this.pending = state.pending;
            });

        this.result = this.usersEffects.unlockAccount$.subscribe((action) => {
            // Desbloqueio efetuado com sucesso
            if (action.type.equals(UsersAction.unlockAccountSuccess)) {
                this.dialogsService.showReceipt(
                        'Conta desbloqueada com sucesso.',
                        `Sua conta foi desbloqueada. Clique no botão abaixo para entrar na sua conta.`,
                        'Entrar',
                        '/',
                        '/',
                    )
                    .afterClosed()
                    .subscribe(() => {
                        this.loginWraper.requestUserLogin();
                    });
            }

            if (action.type.equals(UsersAction.unlockAccountError)) {
                this.store.dispatch({type: ApplicationMessagesAction.genericError});
                this.authorizationPanel.componentInstance.reset();
            }

            if (action.type.equals(UsersAction.secondFactorNeddedToUnlockAccount)) {
                this.requestSecondFactor();
                this.authorizationPanel.componentInstance.reset();
            }
        });
    }

    /**
     * Enviar solicitação de desbloqueio
     */
    public unlockAccount(event: Event) {

        if (this.secondFactorRequired) {
            this.authorizationPanel = this.authorizationWraper.requestUserAuthorization();
            this.authorizationPanel.componentInstance.onTokenAvaliable.subscribe((token) => {
                this.sendUnlockRequest(token);
            });
            return false;
        }

        this.sendUnlockRequest();
    }

    public ngOnDestroy() {
        if (this.authorizationPanel) {
            this.authorizationPanel.componentInstance.end();
        }
        this.result.unsubscribe();
        this.loginWraper.navigateToLogin();
        this.authenticationSubscription.unsubscribe();
    }

    /**
     * Envia requisição ao servidor
     */
    private sendUnlockRequest(token: string = null) {
        const tokens = {
            firstFactor: this.urlToken,
            secondFactor: token,
        };
        this.store.dispatch({type: UsersAction.unlockAccount, payload: tokens});
    }
    /**
     * Requisita o segundo fator de autenticação
     */
    private requestSecondFactor() {
        if (!this.authorizationPanel) {
            this.authorizationPanel = this.authorizationWraper.requestUserAuthorization(AuthorizationScenario.UnlockAccount);
            this.authorizationPanel.componentInstance.onTokenAvaliable.subscribe( (result: AuthorizationResultPayload) => {
                this.sendUnlockRequest(result.token.value);
            });
        }
    }

}
